// extracted by mini-css-extract-plugin
export default {"form":"TodoForm_form__TtTct"};